import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SectionDetail.css';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { useEffect, useRef, useState } from 'react';
import MultipleImage from './Style_variations/MultipleImage';
import SingleImage from './Style_variations/SingleImage';
import SingleVideo from './Style_variations/SingleVideo';
import WithoutMedia from './Style_variations/WithoutMedia';
import React from 'react';
import { convertToAnalyticObject } from '../../utils/analytics';
var SectionDetail = function SectionDetail(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    params = _ref.params;
  var left = params !== undefined && params['Left Media'] === '1' ? true : false;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    titleWrapperHeight = _useState2[0],
    setTitleWrapperHeight = _useState2[1];
  var titleWrapperRef = useRef(null);
  useEffect(function () {
    if (canUseDOM) {
      if (titleWrapperRef.current) {
        setTitleWrapperHeight({
          height: "".concat(titleWrapperRef.current.clientHeight, "px")
        });
      }
    }
  }, []);
  if (!fields) {
    console.info('SectionDetail component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SectionDetail component is empty: please provide data source]");
    }
    return null;
  }
  var title = get(fields, 'data.item.title.jss', '');
  var subtitle = get(fields, 'data.item.subtitle.jss', '');
  var description1 = get(fields, 'data.item.description1.jss', '');
  var description2 = get(fields, 'data.item.description2.jss', '');
  var cTALink = get(fields, 'data.item.cTALink.jss.value', {});
  var ctaLabel = get(fields, 'data.item.ctaLabel.jss.value', '');
  var imgSrc1 = get(fields, 'data.item.media1.jss.value.src', '');
  var alt1 = get(fields, 'data.item.media1.jss.value.alt', '');
  var imgSrc2 = get(fields, 'data.item.media2.jss.value.src', '');
  var alt2 = get(fields, 'data.item.media1.jss.value.alt', '');
  var video = get(fields, 'data.item.mediaVideo.jss.value.src', '');
  var youtubeVideo = get(fields, 'data.item.youtubeURL.jss.value', '');
  var hasCta = Boolean(get(fields, 'data.item.ctaLabel.jss.value'));
  var hasMedia1 = Boolean(get(fields, 'data.item.media1.jss.value.src'));
  var hasMedia2 = Boolean(get(fields, 'data.item.media2.jss.value.src'));
  var hasMediaVideo = Boolean(get(fields, 'data.item.mediaVideo.jss.value.src'));
  var hasYoutubeVideo = Boolean(get(fields, 'data.item.youtubeURL.jss.value'));
  var isMultipleImage = hasMedia1 && hasMedia2;
  var isWithOutMedia = !hasMedia1 && !hasMedia2 && !hasMediaVideo && !hasYoutubeVideo;
  var isSingleVideo = !hasMedia1 && hasMedia2 && (hasMediaVideo || hasYoutubeVideo);
  var isSingleImage = !isMultipleImage && !isWithOutMedia && !isSingleVideo && !hasMedia1 === hasMedia2;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "rtl"
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(isWithOutMedia ? 'section-detail-container__withoutMedia' : left ? 'section-detail-containe__left' : 'section-detail-container', " row")
  }, /*#__PURE__*/React.createElement("div", {
    className: isWithOutMedia ? "col-xs-12 col-md-12 col-lg-6" : "section-detail-container--col col-xs-12 col-md-12 col-lg-5"
  }, /*#__PURE__*/React.createElement("div", {
    ref: titleWrapperRef
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: !left && !isWithOutMedia ? 'hideOnMobile section-detail-title' : 'section-detail-title',
    field: title
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'section-detail-subtitle',
    field: subtitle
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: 'section-detail-description',
    field: description1
  })), hasMedia1 || hasMedia2 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: 'section-detail-description',
    field: description2
  })) : null, hasCta && (hasMedia1 || hasMedia2) ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "section-detail-button btn btn-secondary",
    href: cTALink.href,
    title: "".concat(ctaLabel),
    linktype: cTALink.linktype,
    linksTarget: cTALink.target,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [title.value, ctaLabel]);
    }
  }, ctaLabel)) : null), /*#__PURE__*/React.createElement("div", {
    className: isWithOutMedia ? "col-xs-12 col-md-12 col-lg-5" : "section-detail-container--col--media col-xs-12 col-md-12 col-lg-6"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, !left && !isWithOutMedia ? /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: 'hideOnDesktop section-detail-title',
    field: title
  }) : null), isMultipleImage ? /*#__PURE__*/React.createElement(MultipleImage, {
    imgSrc1: imgSrc1,
    alt1: alt1,
    imgSrc2: imgSrc2,
    alt2: alt2,
    rtl: rtl
  }) : null, isSingleImage ? /*#__PURE__*/React.createElement(SingleImage, {
    imgSrc: hasMedia1 ? imgSrc1 : imgSrc2,
    alt: hasMedia1 ? alt1 : alt2
  }) : null, isSingleVideo ? /*#__PURE__*/React.createElement(SingleVideo, {
    imgSrc2: imgSrc2,
    alt2: alt2,
    hasYoutubeVideo: hasYoutubeVideo,
    video: hasYoutubeVideo ? youtubeVideo : video,
    title: title,
    eventsAnalytics: eventsAnalytics,
    params: params
  }) : null, isWithOutMedia ? /*#__PURE__*/React.createElement(WithoutMedia, {
    title: title,
    description2: description2,
    ctaLabel: ctaLabel,
    cTALink: cTALink,
    titleWrapperHeight: titleWrapperHeight,
    hasCta: hasCta,
    eventsAnalytics: eventsAnalytics,
    params: params
  }) : null))))))))));
};
var commonStyles = "c16hchpj";
export default SectionDetail;